import React, { useState, useRef, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ModalDialog from 'src/common/refactoredComponents/modalDialog/modalDialog';
import SignaturePad from 'react-signature-pad-wrapper';
import {
    Buttons,
    SignatureContainer,
    SignatureWrapper,
    AddSignatureWrapper,
    AddSignatureContent,
    SignatureMessageContainer,
} from 'src/pages/reportUsage/record/components/addSignature/signature.styled.jsx';
import SignatureLogo from 'src/assets/images/Signature.svg';
import SignatureDisabledLogo from 'src/assets/images/SignatureDisabled.svg';
// import Button from 'src/common/components/button/Button.jsx';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';	
import moment from 'moment';
import { getBrowserTimeZoneName } from 'src/utils/dateUtils';
import {
    setLocalSignature,
    setReportUsageFormObject,
} from 'src/pages/reportUsage/redux/action/actionCreators';
import { SET_REMOVE_APPLIED_SIGNATURE } from 'src/pages/reportUsage/redux/action/types';
import { checkIfValidPricedItems } from 'src/pages/reportUsage/utils/eventHandlerUtil';
import { getItemTableDataWithQtyValidation } from 'src/pages/reportUsage/utils/dataModificaionUtil';
import { ReportUsageContext } from 'src/pages/reportUsage';
import { StyledTextDiv } from 'src/pages/reportUsage/utils/reportUsage.styled';
import {
    convertDateToISOString,
    isIpad,
    isLandscape,
    isMobileView,
    isMobileDevice,
    logErrorToConsole,
} from 'src/utils/util';
import {
    HeaderDiv,
    HeaderTitle,
    Icon,
} from 'src/pages/reportUsage/replen/components/selectShipToAddress/ShipAddressModal.styled';
import Close from 'src/assets/images/CloseProduct.svg';
import BottomNavigation from 'src/common/refactoredComponents/bottomNavigation/BottomNavigation';
import { sizes } from 'src/styles/Media.styled';
import { COUNTRY_CODE_JAPN } from 'src/constants/productConstants';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const Signature = ({
    btnDisabled,
    setIsButtonDisabled,
    setFilteredProduct,
    itemTableData,
    fonstSize,
}) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { reportUsageFormObj, setReportUsageFormObj } =
        useContext(ReportUsageContext);
    const [showSignPopUp, setShowSignPopUp] = useState(false);
    const [applyDisabled, setApplyDisabled] = useState(true);
    const [clearDisabled, setClearDisabled] = useState(true);
    const [signatureRemoved, setSignatureRemoved] = useState(false);
    const signRef = useRef({});
    const base64image = useSelector(
        (state) =>
            state.reportUsageRootReducer.localSignatureDetails.base64Image
    );
    const dateOfSignature = useSelector(
        (state) =>
            state.reportUsageRootReducer.localSignatureDetails.dateOfSignature
    );
    const itemsWhenSignatureApplied = useSelector(
        (state) => state.reportUsageRootReducer.signatureItemState
    );
    const removeAppliedSignature = useSelector(
        (state) => state.reportUsageRootReducer.removeAppliedSignature
    );
    const priceOverrideReportUsageVisibility = useSelector(
        (state) => state.loginReducer?.priceOverrideReportUsageVisibility
    );
    const countryCode = localStorage.getItem('countryISOCode');
    useEffectWithErrorLogging(() => {
        const reportUsageObj = { ...reportUsageFormObj, signatureDetails: {} };
        if (
            base64image &&
            base64image.length > 0 &&
            dateOfSignature &&
            dateOfSignature.length > 0
        ) {
            reportUsageObj.signatureDetails = {
                dateOfSignature: convertDateToISOString(
                    dateOfSignature,
                    'original'
                ),
                base64Image: base64image,
            };
        } else {
            delete reportUsageObj.signatureDetails;
        }
        setReportUsageFormObj(reportUsageObj);
    }, [base64image, dateOfSignature]);

    useEffectWithErrorLogging(() => {
        if (itemsWhenSignatureApplied?.length > 0 && removeAppliedSignature) {
            setApplyDisabled(true);
            dispatch(
                setLocalSignature({ base64Image: '', dateOfSignature: '' })
            );
            setSignatureRemoved(true);
            dispatch({ type: SET_REMOVE_APPLIED_SIGNATURE, payload: false });
            setClearDisabled(true);
        }
    }, [removeAppliedSignature]);

    useEffectWithErrorLogging(() => {
        dispatch(setReportUsageFormObject(reportUsageFormObj));
    }, [reportUsageFormObj]);

    const handleClose = () => {
        setShowSignPopUp(false);
    };

    const handleClear = () => {
        signRef.current.clear();
        setApplyDisabled(true);
        setClearDisabled(true);
        dispatch({ type: 'SET_ITEM_STATE_SIGNATURE', payload: [] });
        dispatch(setLocalSignature({ base64Image: '', dateOfSignature: '' }));
        setSignatureRemoved(false);
    };

    const saveSignature = () => {
        const currImgString = signRef.current.toDataURL('image/png');
        setShowSignPopUp(false);
        setSignatureRemoved(false);
        dispatch(
            setLocalSignature({
                base64Image: currImgString,
                dateOfSignature: new Date().toISOString(),
            })
        );
        dispatch({
            type: 'SET_ITEM_STATE_SIGNATURE',
            payload: JSON.parse(JSON.stringify(itemTableData)),
        });
    };

    const getCurrentDate = () => {
        if (dateOfSignature) {
            return `${moment
                .utc(dateOfSignature)
                .local()
                .format('MM/DD/YYYY hh:mm A')} ${getBrowserTimeZoneName()}`;
        }
    };

    const removeSignatureBtnClickHandler = () => {
        dispatch(
            setLocalSignature({
                base64Image: '',
                dateOfSignature: '',
            })
        );
        setApplyDisabled(true);
        dispatch({ type: 'SET_ITEM_STATE_SIGNATURE', payload: [] });
        setClearDisabled(true);
    };

    const getSignatureMessage = () => (
        <>
            <StyledTextDiv
                color="#202124"
                fontSize={countryCode === COUNTRY_CODE_JAPN ? '14px' : '15px'}
                padding="10px 0 0"
            >
                {base64image.length > 0
                    ? t(
                          'reportUsage.review.priceOverrideAndSignature.signatureApplied'
                      )
                    : signatureRemoved && 'Signature Removed:'}
            </StyledTextDiv>
            <StyledTextDiv
                color="#202124"
                fontSize={countryCode === COUNTRY_CODE_JAPN ? '13px' : '14px'}
                width={
                    priceOverrideReportUsageVisibility === 'NOT_VISIBLE' &&
                    isMobileDevice() &&
                    '160px'
                }
                fontFamily="AvenirNextWorld Regular"
                textAlign="left"
            >
                {base64image.length > 0
                    ? getCurrentDate()
                    : signatureRemoved &&
                      t(
                          'reportUsage.procedure.unidSurgery.SurgeryOrReport.SignatureRemoved'
                      )}
            </StyledTextDiv>
        </>
    );

    const handleOnEnd = () => {
        setApplyDisabled(false);
        setClearDisabled(false);
    };
    const getShowCondition = () => {
        if (
            base64image.length === 0 &&
            itemTableData &&
            itemTableData.length > 0
        ) {
            return true;
        } else if (
            signatureRemoved &&
            itemTableData &&
            itemTableData.length > 0
        ) {
            return true;
        } else {
            return false;
        }
    };
    const checkDisable = () => {
        return btnDisabled;
    };
    const onApplySignatureClick = () => {
        if (checkIfValidPricedItems(itemTableData, true, false)) {
            setShowSignPopUp(true);
            setSignatureRemoved(false);
        } else {
            setIsButtonDisabled(true);
            const modifiedItemTableData =
                itemTableData &&
                itemTableData.length > 0 &&
                getItemTableDataWithQtyValidation(itemTableData);
            setFilteredProduct(modifiedItemTableData);
            dispatch({ type: 'SET_ITEMS_PRICING_DONE_FLAG', payload: false });
        }
    };

    const getHeight = () => {
        if (isIpad()) {
            if (isLandscape()) {
                return '65vh';
            }
            return '50vh';
        }
        return '75vh';
    };
    const getContainerHeight = () => {
        const dialogHeight = getHeight();
        if (dialogHeight === '50vh') {
            return '25vh';
        } else if (dialogHeight >= '65vh' && dialogHeight < '75vh') {
            return '35vh';
        } else return '40vh';
    };
    const getMbContainerHeight = () => {
        if (window.innerHeight <= 667) {
            return '50%';
        }
        return '70%';
    };
    return (
        <SignatureWrapper
            withoutPriceOverride={
                priceOverrideReportUsageVisibility === 'NOT_VISIBLE'
            }
            isDeskwithoutPriceOverRide={
                priceOverrideReportUsageVisibility === 'NOT_VISIBLE' &&
                window.innerWidth >= sizes.mobileDevice
                    ? true
                    : false
            }
        >
            <Button
            id={'reportUsage-record-addSignature-addSignatureButton'}
                show={getShowCondition()}
                width={
                    signatureRemoved
                        ? priceOverrideReportUsageVisibility === 'NOT_VISIBLE'
                            ? '160px'
                            : 'auto'
                        : fonstSize
                        ? '160px'
                        : 'auto'
                }
                height={'36px'}
                margin={
                    fonstSize
                        ? '15px 0px 15px 0px'
                        : priceOverrideReportUsageVisibility ===
                              'NOT_VISIBLE' &&
                          window.innerWidth <= sizes.mobileDevice
                        ? '15px 15px 15px 0px'
                        : '24px 0 0 0'
                }
                fontSize={countryCode === COUNTRY_CODE_JAPN ? '14px' : '15px'}
                // secondary
                variant={btnDisabled ? ButtonStyles?.signatureBtnDisabled : ButtonStyles?.signatureBtnEnabled}
                backgroundColor={checkDisable() ? '#E6E6E6' : '#ffffff'}
                color={checkDisable() ? '#888888' : '#1010EB'}
                border={
                    checkDisable() ? '1px solid #BCBCBC' : '1px solid #ffffff'
                }
                boxShadow={'0px 0px 2px #00000029'}
                borderRadius={'17px'}
                clicked={() => {
                    try {
                    onApplySignatureClick();
                    } catch (error) {
                        logErrorToConsole(error);
                    }
                }}
                signature
                disabled={btnDisabled}
            >
                <div style={{ margin: '5px -4px 0', cursor: 'pointer' }}>
                    <img
                        src={
                            checkDisable()
                                ? SignatureDisabledLogo
                                : SignatureLogo
                        }
                        alt="signo"
                    />
                </div>
                <div>
                    {signatureRemoved
                        ? t('reportUsage.record.addSignature.newSignature')
                        : t('reportUsage.record.addSignature.Signature')}{' '}
                </div>
            </Button>
            <Button
                id="reportUsage-record-addSignature-removeSignatureButton"
                show={base64image.length > 0}
                width={
                    priceOverrideReportUsageVisibility === 'NOT_VISIBLE'
                        ? '160px'
                        : 'auto'
                }
                height={
                    priceOverrideReportUsageVisibility === 'NOT_VISIBLE'
                        ? '36px'
                        : '34px'
                }
                margin={
                    priceOverrideReportUsageVisibility === 'NOT_VISIBLE' &&
                    window.innerWidth <= sizes.mobileDevice
                        ? '15px 0 0px 0'
                        : '24px 0 0 0'
                }
                // secondary
                variant ={ButtonStyles?.signatureBtnEnabled}
                // backgroundColor={'#ffffff'}
                // color={'#1010EB'}
                // border={'1px solid #ffffff'}
                borderRadius={'17px'}
                fontSize={
                    priceOverrideReportUsageVisibility === 'NOT_VISIBLE'
                        ? '14px'
                        : '13px'
                }
                clicked={removeSignatureBtnClickHandler}
                signature
            >
                <div>{t('reportUsage.record.addSignature.removeSig')}</div>
            </Button>
            <SignatureMessageContainer
                isDeskwithoutPriceOverRide={
                    priceOverrideReportUsageVisibility === 'NOT_VISIBLE' &&
                    window.innerWidth >= sizes.mobileDevice
                }
            >
                {getSignatureMessage()}
            </SignatureMessageContainer>
            {showSignPopUp && (
                <ModalDialog
                    modalHeight={getHeight()}
                    maxWidth={'820px'}
                    marginTop={isMobileView() ? '7.75rem' : '14rem'}
                    padding={'0px'}
                    zIndex={2000}
                    handleClose={() => handleClose()}
                >
                    <AddSignatureWrapper>
                        <HeaderDiv marginBottom={'18px'} paddingTop={'0px'}>
                            <HeaderTitle>
                                {t('reportUsage.record.addSignature.addSig')}
                            </HeaderTitle>
                            {/* <Icon 
                            id="add-signature-popup-close-icon"
                            path={Close} onClick={handleClose} /> */}
                        </HeaderDiv>
                        <AddSignatureContent>
                            {t(
                                'reportUsage.record.addSignature.addSignatureContent'
                            )}
                        </AddSignatureContent>
                        <SignatureContainer
                            containerHeight={getContainerHeight()}
                            mbContainerHeight={getMbContainerHeight()}
                        >
                            <SignaturePad
                                ref={signRef}
                                options={{
                                    minWidth: 8,
                                    onEnd: handleOnEnd,
                                }}
                                canvasProps={{ style: { height: '100%' } }}
                            />
                        </SignatureContainer>
                    </AddSignatureWrapper>
                    <BottomNavigation
                        justifyContent={'flex-end'}
                        opacity={'1'}
                        position={'absolute'}
                        mbPosition={'fixed'}
                        buttonsPosition={'absolute'}
                        padding={'5px'}
                        mbPadding={'5px'}
                        moblieJustifyContent={'space-evenly'}
                        smalDeviceJustifyContent={'flex-end'}
                        isIPadPotrait={true}
                        iPadPortraitFooterPosition={'absolute'}
                        iPadPortraitJustifyContent={'flex-end'}
                    >
                        <Buttons
                            id="reportUsage-record-addSignature-cancelButton"
                            marginRight={'12px'}
                            onClick={handleClose}
                            buttonColor={'#140F4B'}
                        >
                            {t('userPanel.logoutPopup.cancelButton')}
                        </Buttons>
                        <Buttons
                            id="reportUsage-record-addSignature-clearButton"
                            marginRight={'12px !important'}
                            onClick={handleClear}
                            isClear={true}
                            disabled={clearDisabled}
                        >
                            {t('reportUsage.record.addSignature.clearButton')}
                        </Buttons>
                        <Buttons
                            id="reportUsage-record-addSignature-applySignatureButton"
                            isApply={true}
                            onClick={saveSignature}
                            disabled={applyDisabled}
                        >
                            {t(
                                'reportUsage.record.addSignature.applySignature'
                            )}
                        </Buttons>
                    </BottomNavigation>
                </ModalDialog>
            )}
        </SignatureWrapper>
    );
};

export default Signature;
